import TransferConfirm from 'features/moveMoney/screens/transfer/TransferConfirm/TransferConfirm';
import React from 'react';

export default function TransferConfirmPage() {
  return <TransferConfirm />;
}
